export const INPUT_METHOD: any[] = [
    {
        id: 0,
        title: "Classic (Form)"
    },
    {
        id: 1,
        title: "Import (Upload)"
    }
]